export * from "./src/odata";
//# sourceMappingURL=index.js.map